import { createReducer, on } from "@ngrx/store";
import { IVesselMovement } from "../model/vessel-movement";
import { IQueryResult } from "@pmis3/data-access";
import { LoadVesselMovements, LoadVesselMovementsSuccess, LoadVesselMovementsFail, LoadVesselMovementsByDateRange } from "../action/vesselMovement.action";
import { IDateTimeRange } from "@pmis3/utils";

export enum VesselMovementStateStatus {
  LOADING = "loading vessel movements",
  FAILED = "load vessel movements failed",
  PENDING = "load vessel movements pending",
  SUCCESS = "load vessel movements success"
}
export interface VesselMovementState {
  vesselMovements: IQueryResult<IVesselMovement>;
  error?: string;
  status: VesselMovementStateStatus;
  dateRange?: IDateTimeRange;
}

export const initialVesselMovementState: VesselMovementState = {
    vesselMovements: { query: { pageIndex: 0, pageSize: 0 }, items: [], totalCount: 0 },
    status: VesselMovementStateStatus.PENDING
}

export const vesselMovementReducer = createReducer(
    initialVesselMovementState,
    on(LoadVesselMovements, (state) => ({...state, status: VesselMovementStateStatus.LOADING})),
    on(LoadVesselMovementsByDateRange, (state, action) => ({...state, dateRange: action.dateRange, status: VesselMovementStateStatus.LOADING})),
    on(LoadVesselMovementsSuccess, (state, {result: vesselMovements }) => ({...state, vesselMovements, dateRange: state.dateRange, status: VesselMovementStateStatus.SUCCESS})),
    on(LoadVesselMovementsFail, (state, { error }) => ({...state, error, status: VesselMovementStateStatus.FAILED}))
)